// Mobile header with hamburger menu

interface MobileHeaderProps {
  onMenuClick: () => void
}

export function MobileHeader({ onMenuClick }: MobileHeaderProps) {
  return (
    <header className="mobile-header">
      <img
        src="/img/2TIO_logo.png"
        alt="2TurnItOn"
        className="mobile-header__logo"
      />
      <button
        className="mobile-header__menu"
        onClick={onMenuClick}
        aria-label="Open menu"
      >
        <img
          src="/img/icon/icon_hamburger-menu.svg"
          alt=""
          className="mobile-header__menu-icon"
        />
      </button>
    </header>
  )
}
